import CryptoJS from 'crypto-js';
import Cookie from 'js-cookie';

import fetchData from '@/services/http';
import { GeetestStep1Response } from '@/sfe';
import { API2_HOST } from '@/utils/constants';
import { BYBIT_GUID_KEY } from '@/utils/constants';
import { generateGuid } from '@/utils/guid';
/**
 * 极验
 * @param sourceType
 */
export async function registerGeetest() {
  let loginHash = Cookie.get(BYBIT_GUID_KEY);

  if (!loginHash || loginHash.length !== 36) {
    loginHash = generateGuid();
  }

  return await fetchData.get(`${API2_HOST}/v3/public/user/captcha-info`, {
    body: JSON.stringify({
      type: 'CAPTCHA_TYPE_BEHAVIOR_GEETEST',
      login_name: CryptoJS.MD5(loginHash).toString(),
    }),
    hideError: true,
  });
}
